import { render, staticRenderFns } from "./GeneralReportOfStudents.vue?vue&type=template&id=3495bb3e&scoped=true&"
import script from "./GeneralReportOfStudents.vue?vue&type=script&lang=js&"
export * from "./GeneralReportOfStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3495bb3e",
  null
  
)

export default component.exports